import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getDeliveryStatus } from '../../state/services/bokService';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import BootstrapTable from 'react-bootstrap-table-next';

import { STATIC_HOST,API_HOST, HTTP_PROTOCOL } from '../../config';
import dmeLogo from '../../public/images/logos/dme.png';
import gwLogo from '../../public/images/logos/gw.png';
import teddyLogo from '../../public/images/logos/teddy.png';
import jasonlLogo from '../../public/images/logos/jasonl.png';
import plumLogo from '../../public/images/logos/plum.png';
import Step from './Step';
import LoadingOverlay from 'react-loading-overlay';
import { getCurrentSubdomain } from '../../commons/domain';

class BokStatusPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            identifier: null,
            trackingUrl: null,
            errorMessage: null,
            showScans: false,
            showShips: false,
            showOrders: false,
            showApls: false,
            showSSCCHistory: false,
            showPODs: false,
        };

        moment.tz.setDefault('Australia/Sydney');
    }

    static propTypes = {
        getDeliveryStatus: PropTypes.func.isRequired,
        bokWithPricings: PropTypes.object,
        step: PropTypes.number,
        status: PropTypes.string,
        lastUpdated: PropTypes.string,
        quote: PropTypes.object,
        booking: PropTypes.object,
        lines: PropTypes.array,
        apls: PropTypes.array,
        ssccHistories: PropTypes.array,
        originalLines: PropTypes.array,
        packedLines: PropTypes.array,
        pods: PropTypes.array,
        scans: PropTypes.array,
        etaDate: PropTypes.string,
        lastMilestone: PropTypes.string,
        timestamps: PropTypes.array,
        clientLogoUrl: PropTypes.string,
        match: PropTypes.object,
        isLoggedIn: PropTypes.bool,
        clientname: PropTypes.string
    }

    componentDidMount() {
        const identifier = this.props.match.params.id;

        if (identifier && identifier.length > 32) {
            this.props.getDeliveryStatus(identifier);
            this.setState({identifier});
        } else {
            this.setState({errorMessage: 'We\'re sorry, the tracking number seems to be incorrect. Please contact our support via the chat option during normal business hours.'});
        }
        
    }
    
    UNSAFE_componentWillReceiveProps(newProps) {
        const {errorMessage, booking } = newProps;
        if (booking) {
            this.setState({isLoading: false});
            this.fetchTrackingUrl(booking);
        }
        if (errorMessage) {
            this.setState({errorMessage});
            this.setState({isLoading: false});
        }
    }

    fetchTrackingUrl = async booking => {
        try {
            const url = `${HTTP_PROTOCOL}://${API_HOST}/get-tracking-url/`;
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    fp_company_name: booking.vx_freight_provider
                }),
            });
            const data = await response.json();
            this.setState({ trackingUrl: data.tracking_url_general });
        } catch (error) {
            console.error('Error fetching tracking URL:', error);
            // Handle errors here
        }
    };

    onToggle(stateName) {
        this.setState({[stateName]: !this.state[stateName]});
    }

    onClickPOD(pod_url) {
        const win = window.open(HTTP_PROTOCOL + '://' + STATIC_HOST + '/imgs/' + pod_url, '_blank');
        win.focus();
    }

    onClickShowHide = (ssccHistoryId) => {
        const trs = document.getElementsByClassName(ssccHistoryId);
        if (trs[0].classList.contains('none')) {
            for (let i=0; i<trs.length; i++) {
                trs[i].classList.remove('none');
            }
        } else {
            for (let i=0; i<trs.length; i++) {
                trs[i].classList.add('none');
            }
        }
    }

    render() {
        const {
            scans, apls, originalLines, packedLines, ssccHistories,
            pods, step, status, booking, etaDate, lastUpdated
        } = this.props;
        const {
            showScans, showShips, showOrders, showSSCCHistory,
            showPODs, showApls, isLoading , trackingUrl
        } = this.state;

        let pod_url = null;
        if (booking) {
            if (booking.z_pod_signed_url) {
                pod_url = booking.z_pod_signed_url;
            } else if (booking.z_pod_url) {
                pod_url = booking.z_pod_url;
            }
        }
        
        const step_no = step;
        const steps = [
            {className: 'collect', statusName: 'processing'},
            {className: 'intransit', statusName: 'in transit'}, 
            {className: 'delivering', statusName: 'Out for Delivery'},
            {className: 'delivered', statusName: 'delivered'}
        ];

        const misDeliveries = [
            'Lost In Transit',
            'Damaged',
            'Returning',
            'Returned',
            'Closed',
            'Cancelled',
            'On Hold',
            'Cancel Requested',
        ];
        
        let stepEl = [];
        if (!misDeliveries.includes(status)) {
            stepEl = steps.map((step, index) => {
                if (index < step_no) {
                    return <Step key={index} statusClass="passed" statusName={step.statusName} />;
                } else if (index == step_no) {
                    return <Step key={index} statusClass={step.className} statusName={step.statusName} />;
                } else {
                    return <Step key={index} statusClass="pending" statusName={step.statusName} />;
                }
            });
        }
        const handleCopyConsignmentNumber = () => {
            if (trackingUrl) {
                navigator.clipboard.writeText(booking.b_000_3_consignment_number)
                    .then(() => {
                        console.log('Consignment number copied to clipboard');
                        window.open(trackingUrl, '_blank');
                    })
                    .catch(err => {
                        console.error('Failed to copy consignment number: ', err);
                    });
            }
        };
        const boxStyle = {
            color: 'white',
            padding: '10px',
            marginTop: '20px',
            border: '1px solid #ccc',
            backgroundColor: '#66b3ff',
            textAlign: 'center',
            fontSize: '16px',
            fontWeight: 'bold',
            marginLeft: 'auto',
            cursor: 'pointer',
        };
        const dateOfETA = etaDate ? moment(etaDate, 'DD/MM/YYYY HH:mm').format('DD MMM YYYY') : '';

        const scansColumns = [
            {
                dataField: 'event_timestamp',
                text: 'Scan Date',
                formatter: (cell) => {
                    return moment(cell).format('DD/MM/YYYY HH:mm');
                },
                style: {
                    paddingRight: '5px'
                }
            }, {
                dataField: 'status',
                text: 'Status',
                style: {
                    paddingRight: '5px',
                    minWidth: '50px'
                }
            }, {
                dataField: 'desc',
                text: 'Description'
            }
        ];
        
        const packedLineColumns = [
            {
                dataField: 'e_type_of_packaging',
                text: 'Packaging Unit'
            },{
                dataField: 'e_item',
                text: 'Item Description',
                style: {
                    paddingRight: '5px'
                }
            },
            {
                dataField: 'e_qty',
                text: 'Quantity',
                style: {
                    paddingRight: '5px'
                }
            }, {
                dataField: 'e_dimUOM',
                text: 'DIMS unit of Measure',
                style: {
                    paddingRight: '5px'
                }
            }, {
                dataField: 'e_dimLength',
                text: 'Length(ea)'
            },
            {
                dataField: 'e_dimWidth',
                text: 'Width(ea)'
            },
            {
                dataField: 'e_dimHeight',
                text: 'Height(ea)'
            },
            {
                dataField: 'e_Total_KG_weight',
                text: 'Mass KG(ea)'
            },
            {
                dataField: 'b_pallet_loscam_account',
                text: 'Pallet LOSCAM Number'
            }
        ];

        const originalLineColumns = [
            {
                dataField: 'product',
                text: 'Product'
            },
            {
                dataField: 'e_type_of_packaging',
                text: 'Item Number',
                style: {
                    paddingRight: '5px'
                }
            }, {
                dataField: 'e_item',
                text: 'Item Description',
                style: {
                    paddingRight: '5px'
                }
            }, {
                dataField: 'e_qty',
                text: 'Quantity'
            }
        ];

        const podColumns = [
            {
                dataField: 'z_pod_url',
                text: 'Name',
                formatter: (_, content) => {
                    return <p title={content.z_pod_url}>{getFilename(content.z_pod_url)}</p>;
                },
            },
            {
                dataField: 'z_createdTimeStamp',
                text: 'Uploaded Date',
                formatter: (cell) => {
                    return moment(cell).format('DD/MM/YYYY HH:mm');
                },
                style: {
                    paddingRight: '5px'
                }
            },
            {
                dataField: 'action',
                text: 'Action',
                formatter: (_, content) => {
                    return <div className="row flex-nowrap">
                        <button
                            className="btn btn-primary btn-sm"
                            onClick={() => onClickViewFile(content.z_pod_url)}
                        >
                        View
                        </button>
                    </div>;
                },
            }
        ];

        const aplColumns = [
            {
                dataField: 'api_consignment_id',
                text: 'Consignment Number'
            },
            {
                dataField: 'api_artical_id',
                text: 'Label ID',
                style: {
                    paddingRight: '5px'
                }
            }, {
                dataField: 'api_status',
                text: 'Status',
                style: {
                    paddingRight: '5px'
                }
            }, {
                dataField: 'fp_event_date',
                text: 'Event Date'
            }, {
                dataField: 'fp_event_time',
                text: 'Event time'
            }
        ];

        const clientLogo = booking
            ? booking.b_client_name === 'Jason L'
                ? booking.b_client_name_sub === 'Teddybed Australia Pty Ltd'
                    ? teddyLogo
                    : jasonlLogo
                : booking.b_client_name === 'Plum Products Australia Ltd'
                    ? plumLogo
                    : null
            : null;

        const getFilename = (fullPath) => {
            return fullPath.substring(fullPath.lastIndexOf('/') + 1);
        };

        const onClickViewFile = (filePath) => {
            let filepath = HTTP_PROTOCOL + '://' + STATIC_HOST + filePath;
            filepath = filepath.replace('./static', ''); // For LOCAL/DEV
            filepath = filepath.replace('/opt/s3_public', ''); // For PROD
            const win = window.open(filepath, '_blank');
            win.focus();
        };

        var trs = [];
        for (var ssccHistory of ssccHistories) {
            trs.push(
                <tr key={ssccHistory['id']}>
                    <td><strong>Item</strong></td>
                    <td>{ssccHistory['e_type_of_packaging']}</td>
                    <td>{ssccHistory['e_item']}</td>
                    <td>{ssccHistory['e_dimUOM']}</td>
                    <td>{ssccHistory['e_dimLength']}</td>
                    <td>{ssccHistory['e_dimWidth']}</td>
                    <td>{ssccHistory['e_dimHeight']}</td>
                    <td>{ssccHistory['e_Total_KG_weight']}</td>
                </tr>
            );
            
            for (var sscc of ssccHistory['ssccs']) {
                trs.push(
                    <tr key={sscc['id']}>
                        <td></td>
                        <td><strong>SSCC</strong></td>
                        <td>{sscc['sscc']}</td>
                        <td>{sscc['event_date']}</td>
                        <td>{sscc['event_time']}</td>
                        <td>{sscc['description']}</td>
                        <td>
                            {sscc['sscc_history'].length === 0 ?
                                <strong className='c-red'>No Scan Data</strong>
                                :
                                <button onClick={() => this.onClickShowHide(ssccHistoryId)}>
                                    Show / Hide
                                </button>
                            }
                        </td>
                    </tr>
                );

                const ssccHistoryId = sscc['id'];
                for (var history of sscc['sscc_history']) {
                    trs.push(
                        <tr key={history['id']} className={`none ${ssccHistoryId}`}>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>{history['event_date']}</td>
                            <td>{history['event_time']}</td>
                            <td>{history['description']}</td>
                        </tr>
                    );
                }
            }
        }
        const ssccHistoriesDom = (
            <table className="table table-hover table-bordered sortable fixed_headers"><tbody>{trs}</tbody></table>
        );

        trs = [];
        for (ssccHistory of ssccHistories) {
            if (ssccHistory['no_scan_sscc_cnt'] === 0) {
                continue;
            }

            trs.push(
                <tr key={ssccHistory['id']}>
                    <td><strong>Item</strong></td>
                    <td>{ssccHistory['e_type_of_packaging']}</td>
                    <td>{ssccHistory['e_item']}</td>
                    <td>{ssccHistory['e_dimUOM']}</td>
                    <td>{ssccHistory['e_dimLength']}</td>
                    <td>{ssccHistory['e_dimWidth']}</td>
                    <td>{ssccHistory['e_dimHeight']}</td>
                    <td>{ssccHistory['e_Total_KG_weight']}</td>
                </tr>
            );
            
            for (sscc of ssccHistory['ssccs']) {
                if (sscc['sscc_history'].length > 0) {
                    continue;
                }

                trs.push(
                    <tr key={sscc['id']}>
                        <td></td>
                        <td><strong>SSCC</strong></td>
                        <td>{sscc['sscc']}</td>
                        <td>{sscc['event_date']}</td>
                        <td>{sscc['event_time']}</td>
                        <td>{sscc['description']}</td>
                    </tr>
                );
            }
        }
        const notScannedSSCCHistoriesDom = trs.length === 0 ?
            (<strong>All are scanned</strong>)
            :
            (<table className="table table-hover table-bordered sortable fixed_headers"><tbody>{trs}</tbody></table>);
        const {isLoggedIn, clientname} = this.props;
        const isGW = getCurrentSubdomain().indexOf('gw') !== -1 ||
            (isLoggedIn && clientname === 'Gebrüder Weiss')
            || localStorage.getItem('theme') === 'gw-theme';
        return (
            <LoadingOverlay
                active={isLoading}
                spinner
                text='Get Delivery Status...'
            >
                <section className="status-page">
                    <div className="border border-1 my-5 py-2">
                        <div className="status-main d-flex justify-content-around border-bottom">
                            <div className="left-side mt-4">
                                <div className="row">
                                    <div className="col-md-5 col-sm-5 col-xs-5">
                                        {isGW ? 
                                            <img src={gwLogo} alt="logo" />
                                            :
                                            <React.Fragment>
                                                <img src={dmeLogo} alt="logo" />
                                                <h5 className="tel-number">Tel: (02) 8311 1500</h5>
                                            </React.Fragment>
                                        }
                                        
                                    </div>
                                    <div className="col-md-offset-2 col-md-5 col-sm-offset-2 col-sm-5 col-xs-offset-2 col-xs-5 text-right">
                                        {clientLogo && (<img src={clientLogo} alt="logo" style={{ maxHeight: '100px'}} />) }
                                    </div>
                                </div>
                                <div className="status-stepper text-center align-content-center mt-3 pt-5">
                                    {misDeliveries.includes(status) ? 
                                        <h2 className="title-fail mt-4 pt-5" style={{color: 'blue'}}>Booking {status}</h2> :
                                        <ul className="status-stepper d-flex justify-content-around">
                                            {stepEl}
                                        </ul>
                                    }
                                </div>
                                {trackingUrl && (
                                    <div
                                        style={{
                                            width: '100%',
                                            padding: '23px',
                                            marginBottom: '10px',
                                        }}
                                    >
                                        <div
                                            style={{
                                                float: 'right',
                                                marginBottom: '23px',
                                                maxWidth: '30rem',
                                            }}
                                        >
                                            <div
                                                style={boxStyle}
                                                onClick={handleCopyConsignmentNumber}
                                            >
                                                Freight provider&apos;s tracking page
                                            </div>
                                            <div style={{ fontSize: '1rem', color: 'red' }}>
                                                *note clicking this button will copy consigment - please
                                                paste it into tracking field on url
                                            </div>
                                        </div>
                                    </div>
                                )} 
                            </div>
                            <div className="status-info-right border-left">
                                <table className="table table-bordered table-hover table-sm">
                                    <tbody>
                                        <tr>
                                            <td>Freight Provider</td>
                                            <td>{booking ? booking.vx_freight_provider : ''}</td>
                                        </tr>
                                        <tr>
                                            <td>Consignment</td>
                                            <td>{booking ? booking.b_000_3_consignment_number : '' }</td>
                                        </tr>
                                        <tr>
                                            <td>Your Sales Order</td>
                                            <td>{booking ? booking.b_client_sales_inv_num : ''}</td>
                                        </tr>
                                        <tr>
                                            <td>Delivery ETA</td>
                                            <td>{dateOfETA}</td>
                                        </tr>
                                        <tr>
                                            <td>Updated ETA</td>
                                            <td>{booking && booking.s_06_Latest_Delivery_Date_Time_Override ? moment(booking.s_06_Latest_Delivery_Date_Time_Override).format('DD MMM YYYY') : ''}</td>
                                        </tr>
                                        <tr>
                                            <td>Delivering To</td>
                                            <td>{booking ? `${booking.b_057_b_del_address_state} ${booking.b_059_b_del_address_postalcode}` : ''}</td>
                                        </tr>
                                        <tr>
                                            <td>Service</td>
                                            <td>{booking ? booking.vx_serviceName : ''}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                {pod_url && <a href="#" onClick={() => this.onClickPOD(pod_url)}>Proof Of Delivery</a>}
                                <br/>
                                <br/>
                                <div className="date">
                                    Updated: {lastUpdated}
                                </div>
                            </div>
                        </div>
                        <div className="status-detail pt-3 px-5 border-bottom pb-3">
                            <h5 className="ml-4">View details:</h5>
                            <div className="detail-content ps-2">
                                <div className="accordion" id="accordion">
                                    <div className="card">
                                        <div className="card-header p-0">
                                            <a className="btn text-white d-block text-left" data-toggle="collapse" href="#collapseOne" onClick={() => this.onToggle('showScans')}>
                                                &nbsp;<i className={showScans ? 'fa fa-minus' : 'fa fa-plus'} ></i>
                                                &nbsp; View Tracking History
                                            </a>
                                        </div>
                                        <div id="collapseOne" className="collapse">
                                            <div className="card-body">
                                                {(scans && scans.length != 0)  ? <BootstrapTable
                                                    keyField="id"
                                                    data={ scans }
                                                    columns={ scansColumns }
                                                    bootstrap4={ true }
                                                    bordered={ false }
                                                /> : 'No item information was provided to report here'}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card">
                                        <div className="card-header p-0">
                                            <a className="collapsed btn text-white d-block text-left" data-toggle="collapse" href="#collapseTwo" onClick={() => this.onToggle('showShips')}>
                                                &nbsp;<i className={showShips ? 'fa fa-minus' : 'fa fa-plus'} ></i>
                                                &nbsp; View Packages Shipped
                                            </a>
                                        </div>
                                        <div id="collapseTwo" className="collapse">
                                            <div className="card-body">
                                                {packedLines && packedLines.length != 0 ? <BootstrapTable
                                                    keyField="pk_lines_id"
                                                    data={ packedLines }
                                                    columns={ packedLineColumns }
                                                    bootstrap4={ true }
                                                    bordered={ false }
                                                /> : 'No item information was provided to report here'}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card">
                                        <div className="card-header p-0">
                                            <a className="collapsed btn text-white d-block text-left" data-toggle="collapse" href="#collapseThree" onClick={() => this.onToggle('showOrders')}>
                                                &nbsp;<i className={showOrders ? 'fa fa-minus' : 'fa fa-plus'} ></i>
                                                &nbsp; View a list of items in your packages
                                            </a>
                                        </div>
                                        <div id="collapseThree" className="collapse">
                                            <div className="card-body">
                                                {(originalLines && originalLines.length != 0) ? <BootstrapTable
                                                    keyField="pk_lines_id"
                                                    data={ originalLines }
                                                    columns={ originalLineColumns }
                                                    bootstrap4={ true }
                                                    bordered={ false }
                                                /> : 'No item information was provided to report here'}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card">
                                        <div className="card-header p-0">
                                            <a 
                                                className="collapsed btn text-white d-block text-left" data-toggle="collapse"
                                                href="#collapseFour" onClick={() => this.onToggle('showApls')}
                                            >
                                                &nbsp;<i className={showApls ? 'fa fa-minus' : 'fa fa-plus'} ></i>
                                                &nbsp; View each item status from Freight Provider
                                            </a>
                                        </div>
                                        <div id="collapseFour" className="collapse">
                                            <div className="card-body">
                                                {(apls && apls.length != 0) ? <BootstrapTable
                                                    keyField="id"
                                                    data={ apls }
                                                    columns={ aplColumns }
                                                    bootstrap4={ true }
                                                    bordered={ false }
                                                /> : 'No information'}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card">
                                        <div className="card-header p-0">
                                            <a
                                                className="collapsed btn text-white d-block text-left" data-toggle="collapse"
                                                href="#collapseFive" onClick={() => this.onToggle('showSSCCHistory')}
                                            >
                                                &nbsp;<i className={showSSCCHistory ? 'fa fa-minus' : 'fa fa-plus'} ></i>
                                                &nbsp; View each SSCC status from Freight Provider
                                            </a>
                                        </div>
                                        <div id="collapseFive" className="collapse">
                                            <div className="card-body">
                                                <h4>SSCC with no scan</h4>
                                                {(showSSCCHistory && ssccHistories.length != 0) && notScannedSSCCHistoriesDom}
                                                <hr />
                                                <h4>All SSCC result</h4>
                                                {(showSSCCHistory && ssccHistories.length != 0) ? ssccHistoriesDom : 'No information'}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card">
                                        <div className="card-header p-0">
                                            <a
                                                className="collapsed btn text-white d-block text-left" data-toggle="collapse"
                                                href="#collapseSix" onClick={() => this.onToggle('showPODs')}
                                            >
                                                &nbsp;<i className={showPODs ? 'fa fa-minus' : 'fa fa-plus'} ></i>
                                                &nbsp; View POD List
                                            </a>
                                        </div>
                                        <div id="collapseSix" className="collapse">
                                            <div className="card-body">
                                                {(pods && pods.length != 0) ? <BootstrapTable
                                                    keyField="id"
                                                    data={ pods }
                                                    columns={ podColumns }
                                                    bootstrap4={ true }
                                                    bordered={ false }
                                                /> : 'No POD was attached to this order'}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="status-footer row ps-4 pt-2">
                            <a className="col-12 text-center" data-toggle="modal" data-target="#myModal" style={{color: 'red'}} href="#">Important Information re Freight Delays</a>
                            <div className="modal" id="myModal">
                                <div className="modal-dialog modal-lg">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h4 className="modal-title text-left">Freight Delivery and Potential Delay Updates</h4>
                                            <button type="button" className="close px-2 py-0" data-dismiss="modal">&times;</button>
                                        </div>
                                
                                        <div className="modal-body">
                                            <p className="blurb-text">
                                                Please note that your order may arrive in multiple deliveries due to the way that &apos;big and bulky&apos; items are sorted and scanned. Rest assured that the rest of your order will arrive soon.
                                            </p>
                                            <p className="blurb-text">
                                                If the order status says &apos;Delivered&apos; and there are still undelivered items in your order, you may submit an inquiry in the chat window on this page. Our Customer Service team will check with our delivery partner and get back to you as soon as possible.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </LoadingOverlay>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        errorMessage: state.bok.errorMessage,
        status: state.bok.deliveryStatus,
        step: state.bok.deliveryStep,
        quote: state.bok.quote,
        booking: state.bok.booking,
        lines: state.bok.lines,
        originalLines: state.bok.originalLines,
        packedLines: state.bok.packedLines,
        scans: state.bok.scans,
        apls: state.bok.apls,
        ssccHistories: state.bok.ssccHistory,
        etaDate: state.bok.etaDate,
        lastUpdated: state.bok.lastUpdated,
        lastMilestone: state.bok.lastMilestone,
        timestamps: state.bok.timestamps,
        pods: state.bok.pods,
        clientLogoUrl: state.bok.clientLogoUrl,
        isLoggedIn: state.auth.isLoggedIn,
        clientname: state.auth.clientname
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getDeliveryStatus: (identifier) => dispatch(getDeliveryStatus(identifier)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(BokStatusPage);


// WEBPACK FOOTER //
// ./src/pages/customer/BokStatusPage.js